export default __webpack_public_path__ + "static/media/UndercurrentBTN.63ab08d9.otf";